module.exports = __webpack_public_path__ + "img/ym-bg.ca17a734.jpg";